"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var redux_1 = require("redux");
var react_aad_msal_1 = require("react-aad-msal");
var initialState = {
    initializing: false,
    initialized: false,
    idToken: null,
    accessToken: null,
    state: react_aad_msal_1.AuthenticationState.Unauthenticated
};
var rootReducer = function (state, action) {
    if (state === void 0) { state = initialState; }
    switch (action.type) {
        case react_aad_msal_1.AuthenticationActions.Initializing:
            return __assign(__assign({}, state), { initializing: true, initialized: false });
        case react_aad_msal_1.AuthenticationActions.Initialized:
            return __assign(__assign({}, state), { initializing: false, initialized: true });
        case react_aad_msal_1.AuthenticationActions.AcquiredIdTokenSuccess:
            return __assign(__assign({}, state), { idToken: action.payload });
        case react_aad_msal_1.AuthenticationActions.AcquiredAccessTokenSuccess:
            return __assign(__assign({}, state), { accessToken: action.payload });
        case react_aad_msal_1.AuthenticationActions.AcquiredAccessTokenError:
            return __assign(__assign({}, state), { accessToken: null });
        case react_aad_msal_1.AuthenticationActions.LoginSuccess:
            return __assign(__assign({}, state), { account: action.payload.account });
        case react_aad_msal_1.AuthenticationActions.LoginError:
        case react_aad_msal_1.AuthenticationActions.AcquiredIdTokenError:
        case react_aad_msal_1.AuthenticationActions.LogoutSuccess:
            return __assign(__assign({}, state), { idToken: null, accessToken: null, account: null });
        case react_aad_msal_1.AuthenticationActions.AuthenticatedStateChanged:
            return __assign(__assign({}, state), { state: action.payload });
        default:
            return state;
    }
};
exports.basicReduxStore = redux_1.createStore(rootReducer, 
// Enable the Redux DevTools extension if available
/// See more: https://chrome.google.com/webstore/detail/redux-devtools/lmhkpmbekcpmknklioeibfkpmmfiblj
window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__());
//# sourceMappingURL=reduxStore.js.map